// Englische Texte: Seiteninhalte, Sorten, Standardseiten. Schluessel = deutscher Text wie auf der Seite, Wert = englischer Text.
window.NadosEN = window.NadosEN || {};
(function (w) {
  var d = {
  "vegan.": "vegan.",
  "NEU": "NEW",
  "Neu": "New",
  "Saisonale Donuts": "Seasonal donuts",
  "Vergiss alles, was du über Donuts wusstest. In unserer kleinen Manufaktur entstehen handgemachte Donuts für alle, die das Unerwartete lieben. Erlebe Geschmack jenseits der puren Süße, mit pikanten Nuancen, belebender Säure": "Forget everything you knew about donuts. In our small workshop we make handmade donuts for everyone who loves the unexpected. Experience flavour beyond pure sweetness, with savoury nuances, invigorating acidity",
  "und herben Noten. Hier werden handgemachte Kreationen aus persönlichen kulinarischen Einflüssen geformt.": "and bitter notes. Here, handmade creations are shaped by personal culinary influences.",
  "Vergiss alles, was du über Donuts wusstest. In unserer kleinen Manufaktur entstehen handgemachte Donuts für alle, die das Unerwartete lieben. Erlebe Geschmack jenseits der puren Süße, mit pikanten Nuancen, belebender Säure und herben Noten. Hier werden handgemachte Kreationen aus persönlichen kulinarischen Einflüssen geformt.": "Forget everything you knew about donuts. In our small workshop we make handmade donuts for everyone who loves the unexpected. Experience flavour beyond pure sweetness, with savoury nuances, invigorating acidity and bitter notes. Here, handmade creations are shaped by personal culinary influences.",
  "1. & 3. Samstag –": "1st & 3rd Saturday –",
  "Abholtermine: 1. & 3. Samstag –": "Pickup dates: 1st & 3rd Saturday –",
  "Nados Donuts Verkaufsstand": "Nados Donuts market stall",
  "Frisch belegte Nados Donuts": "Freshly topped Nados Donuts",
  "Donut": "Donut",
  "In unserer Manufaktur": "At our workshop",
  "Datum *": "Date *",
  "Uhrzeit *": "Time *",
  "Bitte Abholdatum und -uhrzeit wählen, um eine Donuts in den Warenkorb zu legen.": "Please choose a pickup date and time to add donuts to your cart.",
  "Bitte Abholdatum und -uhrzeit wählen, um Donuts in den Warenkorb zu legen.": "Please choose a pickup date and time to add donuts to your cart.",
  "Abholzeit wählen": "Choose pickup time",
  "Bitte wähle vor dem Bezahlen Abholung oder Lieferung – bei Abholung mit Datum und Uhrzeit.": "Before paying, please choose pickup or delivery – for pickup with date and time.",
  "Abholung oder Lieferung wählen": "Choose pickup or delivery",
  "Deine Donut Auswahl": "Your donut selection",
  "vegan.hangemacht.nachhaltig.": "vegan.handmade.sustainable.",
  "vegan.handgemacht.nachhaltig.": "vegan.handmade.sustainable.",
  "6 Donuts aus unserer limitierten Edition.": "6 donuts from our limited edition.",
  "Auswahl (4 Donuts)": "Selection (4 donuts)",
  "Auswahl (6 Donuts)": "Selection (6 donuts)",
  "Hefeteigdonut": "Yeast donut",
  "Hefeteigdonut & Cakedonut": "Yeast donut & cake donut",
  "Hefeteigdonut (saisonal)": "Yeast donut (seasonal)",
  "Feingebäck • Ganache • Saisonale Akzente": "Fine pastry • Ganache • Seasonal accents",
  "Individuelle Kompositionen ab 30 Gästen.": "Individual compositions from 30 guests.",
  "Zum Warenkorb": "Go to cart",
  "Für diese Box sind noch keine Sorten hinterlegt.": "No flavours have been added to this box yet.",
  "Sorten": "Flavours",
  "Sorten:": "Flavours:",
  "Box": "Box",
  "Schließen": "Close",
  "Anzahl Boxen": "Number of boxes",
  "Weniger": "Fewer",
  "Mehr": "More",
  "Neue Box": "New box",
  "Eine Box mit 6 Donuts.": "A box with 6 donuts.",
  "4er Box – deine Wahl": "Box of 4 – your choice",
  "6er Box – deine Wahl": "Box of 6 – your choice",
  "4er Box – unsere Wahl": "Box of 4 – our choice",
  "6er Box – unsere Wahl": "Box of 6 – our choice",
  "6er News-Box": "News box of 6",
  "Eine Box mit 4 Donuts – wähle deine Lieblingssorten aus unserem Sortiment.": "A box of 4 donuts – choose your favourite flavours from our range.",
  "Eine Box mit 6 Donuts – wähle deine Lieblingssorten aus unserem Sortiment.": "A box of 6 donuts – choose your favourite flavours from our range.",
  "Eine Box mit 4 Donuts – von uns zusammengestellt.": "A box of 4 donuts – put together by us.",
  "Eine Box mit 6 Donuts – von uns zusammengestellt.": "A box of 6 donuts – put together by us.",
  "Eine Box mit 6 Donuts – unsere neuen Sorten, von uns zusammengestellt.": "A box of 6 donuts – our new flavours, put together by us.",
  "Wähle deine Box": "Choose your box",
  "In den Warenkorb": "Add to cart",
  "Aprikose & Joghurtmousse": "Apricot & yoghurt mousse",
  "Brombeere & Baiser": "Blackberry & meringue",
  "Stachelbeeren & Kokosnuss": "Gooseberries & coconut",
  "Pistazie & Mousse": "Pistachio & mousse",
  "Passionsfrucht & Kokosnuss": "Passion fruit & coconut",
  "Mango & Löwenmähne": "Mango & lion’s mane",
  "Halloween Edition - 6 Donuts": "Halloween Edition - 6 donuts",
  "Sanddorn": "Sea buckthorn",
  "Birne & Zitronengras": "Pear & lemongrass",
  "Orangenzest": "Orange zest",
  "Himbeere & Rosmarin": "Raspberry & rosemary",
  "Zartbitter & Mousse": "Dark chocolate & mousse",
  "Zartbitterschokolade & Mousse": "Dark chocolate & mousse",
  "Feigen & Nüsse": "Figs & nuts",
  "Cakedonut mit Schokoladenglasur, Asaane und Mousse (4 Donuts)": "Cake donut with chocolate glaze, asaane and mousse (4 donuts)",
  "Hefeteigdonut mit Kürbis-Glasur, Gewürzen, Schlagsahne und Kürbiskernen (4 Donuts)": "Yeast donut with pumpkin glaze, spices, whipped cream and pumpkin seeds (4 donuts)",
  "Löwenmähnen Nougat, Mangocurd, Mangocreme & Kochbananenchips (6 Donuts)": "Lion’s mane nougat, mango curd, mango cream & plantain chips (6 donuts)",
  "Speisekarte": "Menu",
  "Saisonal": "Seasonal",
  "6er-Box unsere Wahl": "Box of 6 – our choice",
  "6er-Box deine Wahl": "Box of 6 – your choice",
  "Deine Wahl 4 Donuts": "Your choice 4 donuts",
  "Veganes Donut Catering für jede Feiern oder Anlass in Leipzig.": "Vegan donut catering for every party or occasion in Leipzig.",
  "Veganes Donut Catering für jede Feier oder jeden Anlass in Leipzig.": "Vegan donut catering for every party or occasion in Leipzig.",
  "24 Donuts, 3 Sorten gemischt": "24 donuts, 3 flavours mixed",
  "48 Donuts, 3 Sorten gemischt": "48 donuts, 3 flavours mixed",
  "Mehrweg-Verpackung": "Reusable packaging",
  "Lieferpauschale": "Flat delivery fee",
  "1 Woche Vorlaufzeit": "1 week lead time",
  "2 Wochen Vorlaufzeit": "2 weeks lead time",
  "Lieferung inklusive": "Delivery included",
  "Individuelles Design": "Individual design",
  "Lieferung & Aufbau inklusive": "Delivery & set-up included",
  "Ab 100 Donuts, frei kombinierbar": "From 100 donuts, freely combinable",
  "ab 400 €": "from €400",
  "Termin und Auswahl per Kontaktformular oder Telefon.": "Date and selection via contact form or phone.",
  "Du planst ein Event?": "Planning an event?",
  "Wir erstellen dir ein unverbindliches Angebot.": "We’ll put together a non-binding quote for you.",
  "Neues Paket": "New package",
  "Leistung 1": "Service 1",
  "Leistung 2": "Service 2",
  "Beliebteste Wahl": "Most popular",
  "Hinter Nados Donuts steckt kein Zufall, sondern meine ganz eigene Geschichte. Seit über 10 Jahren bewege ich mich in der Welt der Patisserie. Mit einem speziellen Fokus: Ich liebe es, die ganze Bakery-Palette mit neuen, lebendigen Geschmackskonzepten zu verweben.": "Nados Donuts is no coincidence – it is my very own story. For more than 10 years I have been working in the world of patisserie, with a special focus: I love weaving the whole bakery range together with new, vibrant flavour concepts.",
  "In meiner Manufaktur entstehen Donuts aus den unterschiedlichsten Texturen. Von fluffigem Hefeteig und saftigen Rührteig bis hin zu crunchy Blätter- oder zartem Brandteig.": "In my workshop, donuts are made from the most varied textures – from fluffy yeast dough and moist sponge batter to crunchy puff pastry or delicate choux pastry.",
  "Was Nados so besonders macht? Mein Geschmacksprofil ist geprägt von meiner kulinarischen DNA, die ich modern interpretiere. Ich kombiniere bekannte Texturen mit Aromen, die eine eigene Sprache sprechen. Wie meine Sorte": "What makes Nados so special? My flavour profile is shaped by my culinary DNA, which I interpret in a modern way. I combine familiar textures with aromas that speak a language of their own – like my flavour",
  "Sobolo": "Sobolo",
  "Rahel, Gründerin von Nados Donuts": "Rahel, founder of Nados Donuts",
  "Teller mit Nados Donuts": "Plate with Nados Donuts",
  "Rahel in der Manufaktur": "Rahel in the workshop",
  "Manufaktur": "Workshop",
  "Dienstag - Samstag 11:00 - 17:00 Uhr": "Tuesday – Saturday 11:00 – 17:00",
  "Dienstag – Samstag 11:00 – 17:00 Uhr": "Tuesday – Saturday 11:00 – 17:00",
  "Name": "Name",
  "Pflichtangabe": "Required",
  "Deine Nachricht": "Your message",
  "Hey, danke! Deine Nachricht wurde versendet. Wir melden uns schnellstmöglich bei dir.": "Hey, thanks! Your message has been sent. We’ll get back to you as soon as possible.",
  "Deutschland": "Germany",
  "Impressum": "Legal notice",
  "Datenschutzerklärung": "Privacy policy",
  "Seite nicht gefunden": "Page not found",
  "Diese Seite gibt es leider nicht (mehr).": "Sorry, this page does not exist (any more).",
  "Zur Startseite": "Back to the homepage",
  "inkl. MwSt., zzgl. ggf. Versand": "incl. VAT, plus shipping if applicable",
  "Aktualisieren": "Update",
  "Zu den Donuts": "To the donuts",
  "Menge": "Quantity",
  "In dieser Kollektion sind noch keine Produkte.": "There are no products in this collection yet.",
  "Kollektionen": "Collections",
  "Bald geht's los": "Coming soon",
  "Bald geht’s los": "Coming soon",
  "Passwort": "Password",
  "Shop betreten": "Enter shop",
  "Diese Sorte gibt es in unseren Donut-Boxen.": "This flavour is available in our donut boxes.",
  "Zu den Boxen": "To the boxes",
  "Variante": "Variant",
  "Ausverkauft": "Sold out",
  "Suche": "Search",
  "Suchbegriff": "Search term",
  "Keine Ergebnisse für „": "No results for “",
  "“.": "”.",
  "Geschenkgutschein –": "Gift card –",
  "Dein Gutschein": "Your gift card",
  "Dieser Gutschein ist nicht mehr gültig.": "This gift card is no longer valid.",
  "Gutscheincode": "Gift card code",
  "Gültig bis": "Valid until",
  "Jetzt einlösen": "Redeem now",
  "Warenkorb": "Cart",
  "Gesamtsumme:": "Total:",
  "Neuer Schritt": "New step",
  "Beschreibung": "Description",
  "Neue Sorte": "New flavour",
  "Unsere": "Our",
  "6 Donuts mit unseren neuesten Sorten – von uns zusammengestellt.": "6 donuts with our newest flavours – put together by us."
};
  for (var k in d) { if (Object.prototype.hasOwnProperty.call(d, k)) w[k] = d[k]; }
})(window.NadosEN);
